<template>
  <base-layout>
    <paginate
      :page="parseInt(page)"
      :per-page="perPage"
      :total="total"
      @on-page-change="changePage" />
    <v-data-table
      :headers="headers"
      :items-per-page="15"
      :items="mapedData"
      :loading="loading"
      disable-sort
      hide-default-footer
      class="elevation-1">
      <template v-slot:[`item.view`]="{ item }">
        <a v-if="item.operation === 'update'" @click="showModal(item)">view</a>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      width="600px"
    >
      <dealer-log-detail :dealer="selectedItems.data" />
    </v-dialog>
  </base-layout>
</template>

<script>
import DealerProvider from '@/resources/DealerProvider'
import dayjs from 'dayjs'
import DealerLogDetail from '../components/DealerLogDetail'
import { mapActions } from 'vuex'

const dealerService = new DealerProvider()
export default {
  components: {
    DealerLogDetail
  },
  data: () => ({
    dialog: false,
    searchText: '',
    loading: false,
    perPage: 15,
    total: 15,
    page: 1,
    data: [],
    headers: [
      { text: 'Date', value: 'date' },
      { text: 'IP', value: 'ip' },
      { text: 'User', value: 'user' },
      { text: 'Operation', value: 'operation' },
      { text: 'View', value: 'view' }
    ],
    selectedItems: {}
  }),
  computed: {
    dealerId () {
      return this.$route.params.id ? this.$route.params.id : 0
    },
    mapedData () {
      return this.data.map(d => ({
        id: d.id,
        operation: d.operation,
        user: d.user.username,
        date: dayjs(d.createdAt).format('DD-MM-YYYY HH:mm'),
        ip: d.ip,
        data: d.data
      }))
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Style/setSnackbar'
    }),
    showModal (item) {
      this.dialog = true
      this.selectedItems = item
    },
    print (id) {
      const routeData = this.$router.resolve({name: 'PrintDealer', params: { id }})
      window.open(routeData.href, '_blank')
    },
    changePage (page) {
      this.page = page
      this.getData()
    },
    searchItem () {
      this.page = 1
      this.getData()
    },
    async getData () {
      this.loading = true
      try {
        const query = `page=${this.page}&limit=${this.perPage}&search=${this.searchText}`
        const { data } = await dealerService.getDealerLog(this.dealerId, query)
        this.total = data.total
        this.data = data.results
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
